import React from "react";
import "./sentry";

import ReactDOM from "react-dom/client";
import { ThemeProvider, CssBaseline } from "@mui/material";
import { theme } from "./theme";
import { RouterProvider } from "react-router-dom";
import { router } from "./router";

import "./i18n";
import "./styles/fonts.css";
import "flag-icons/css/flag-icons.min.css";
import * as Sentry from "@sentry/react";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <Sentry.ErrorBoundary fallback={<div />}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <RouterProvider router={router} />
      </ThemeProvider>
    </Sentry.ErrorBoundary>
  </React.StrictMode>
);
